// The SOPs page's call to /api/ai (actions sop_*): the login's token, one plain sentence on failure.
import { supabase } from './supabase'
export async function sopApi(body) {
  const { data: { session } } = await supabase.auth.getSession()
  const r = await fetch('/api/ai', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + (session?.access_token || '') }, body: JSON.stringify(body) })
  const j = await r.json().catch(() => ({}))
  if (!r.ok || j.error) throw new Error(j.error || 'The request failed (' + r.status + ')')
  return j
}
